import { Dialog, DialogContent, DialogTitle, Box, Divider, Grid, Typography, Stack, IconButton, Tooltip, Button, DialogActions } from "@mui/material";
import React, { useState } from "react";
import SubCard from "ui-component/cards/SubCard";
import UpdateEducationDetails from "../UpdateEducationDetails";
import moment from "moment";
import EditIcon from '@mui/icons-material/Edit';
import useRequestIdGenerater from "customhooks";
import useTimeStamp from "reuseableTable/uniquetimestamp/GenerateUniqueTimeStamp";
import { dispatch } from "store";
import { openSnackbar } from "store/slices/snackbar";
import axios from "axios";
import { Delete } from "@mui/icons-material";

const EducationDetailsCard = ({
  alumniDetails,
  handleAddEducatiobNavigation,
  handleNavigate,
  IsConnection,
  setAlumniDetails
}) => {

  const [openEdit, setOpenEdit] = useState(false)
  const [alumniId, setAlumniId] = useState('')
  const [workDetails, setWorkingDetails] = useState({})

  const [openDelete, setOpenDelete] = useState(false)
  const [removeType, setRemoveType] = useState("")
  const [removeDetails, setRemoveDetails] = useState({})


  const RequestId = useRequestIdGenerater();
  const { rendomRequestId, generateTimeStamp } = useTimeStamp();

  const handleNavigateIndividualEdit = (alumniId, details) => {
    setAlumniId(alumniId)
    setWorkingDetails(details)
    setOpenEdit(true)
  }

  const handleOpenDelete = (alumniId, details, removeType) => {
    setRemoveType(removeType)
    setAlumniId(alumniId)
    setRemoveDetails(details)
    setOpenDelete(true)
  }

  const handleDeleteWorkExperience = () => {
    axios
      .delete(`/v1/alumni/remove-details?alumniId=${alumniId}&removedTypeId=${removeDetails?.id}&removeType=${removeType}`, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem(
            "serviceToken"
          )}`,
          "Content-Type": "application/json",
          requestId: RequestId(
            Math.floor(1000 + Math.random() * 9999),
            Math.floor(1000 + Math.random() * 9999 + rendomRequestId)
          ),
        },
      })
      .then((value) => {
        setAlumniDetails(value?.data?.data)
        setOpenDelete(false)
        generateTimeStamp();
        dispatch(
          openSnackbar({
            open: true,
            message: "Deleted Successfully.",
            variant: "alert",
            alert: {
              color: "success",
            },
            close: false,
          })
        );
        setOpenEdit(false)

      })
      .catch((error) => {
        if (error.response.status === 404) {
          generateTimeStamp();
          dispatch(
            openSnackbar({
              open: true,
              message: error.response.data.Msg,
              variant: "alert",
              alert: {
                color: "error",
              },
              close: false,
            })
          );
        } else {
          dispatch(
            openSnackbar({
              open: true,
              message: "Something went wrong",
              variant: "alert",
              alert: {
                color: "error",
              },
              close: false,
            })
          );
          generateTimeStamp();
        }
      });
  }

  return (
    <>
      <SubCard
        sx={{
          p: 1,
          mt: 2,
          overflow: "auto",
          "&::-webkit-scrollbar": {
            width: "0.5em",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#ffffff",
          },
        }}
        title={
          <div style={{ display: "flex", alignItems: "center" }}>
            <Typography
              sx={{
                fontWeight: 500,
                display: "flex",
                alignItems: "center",
              }}
            >
              {/* <InfoIcon sx={{ marginRight: 1 }} /> */}
              <span style={{ color: "#245081", fontSize: "18px" }}>
                Education
              </span>
            </Typography>
          </div>
        }
        secondary={
          <>
            {!IsConnection && (
              <>
                {alumniDetails?.educationDetails !== null && (
                  <div style={{ cursor: "pointer" }}>
                    <img
                      height="20px"
                      onClick={() =>
                        handleAddEducatiobNavigation(alumniDetails?.id)
                      }
                      alt="icon"
                      src="/assets/images/icons/addIcon.svg"
                    />
                    {/* <img
                      height="20px"
                      style={{ marginLeft: "20px" }}
                      onClick={() => handleNavigate(alumniDetails?.id)}
                      alt="icon"
                      src="/assets/images/icons/editIcon.svg"
                    /> */}
                  </div>
                )}
              </>
            )}
          </>
        }
      >
        <Grid container direction="column" spacing={2}>
          {alumniDetails?.educationDetails === null ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                padding: "10px",
              }}
            >
              {!IsConnection ? (
                <>
                  <img
                    height="40px"
                    onClick={() =>
                      handleAddEducatiobNavigation(alumniDetails?.id)
                    }
                    alt="icon"
                    src="/assets/images/icons/addPlus.svg"
                  />
                </>
              ) : (
                "No Education Deatils Provided"
              )}
            </div>
          ) : (
            <>
              {alumniDetails?.educationDetails?.map((data, idx) => (
                <Grid item xs={12} key={idx}>
                  <Box
                    sx={{
                      border: "1px solid #E2E5EA",
                      borderRadius: "10px",
                      p: 2,
                      mb: 1,
                    }}
                  >
                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                      <Box>
                        <Typography variant="subtitle1" fontWeight={600}>
                          {data?.affiliation}
                        </Typography>
                        <Typography fontSize="15px" fontWeight={500}>
                          {data?.instituteName}
                        </Typography>
                        <Typography fontSize="12px" fontWeight={500}>
                          {data?.courseName}
                        </Typography>
                        <Typography fontSize="12px" fontWeight={500}>
                          {data?.educationLevel}
                        </Typography>
                        {data?.joiningDate && (
                          <Typography fontSize="12px" color="textSecondary">
                            {moment(data?.joiningDate).format("MMMM-YYYY")} -{" "}
                            {data?.endDate
                              ? moment(data?.endDate).format("MMMM-YYYY")
                              : "Current"}
                          </Typography>
                        )}
                      </Box>

                      {!IsConnection && (
                        <Grid>
                          <Tooltip title="Edit Education">
                            <IconButton
                              size="small"
                              color="primary"
                              onClick={() => handleNavigateIndividualEdit(alumniDetails?.id, data)}

                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>

                          <Tooltip title="Delete Details">
                            <IconButton
                              size="small"
                              color="error"
                              onClick={() => handleOpenDelete(alumniDetails?.id, data, "EducationDetails")}
                              sx={{
                                ml: 1,
                                bgcolor: "#f5f5f5",
                                "&:hover": { bgcolor: "#e0e0e0" },
                              }}
                            >
                              <Delete fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Grid>
                      )}
                    </Stack>
                  </Box>
                </Grid>
              ))}
            </>

          )}
          <Box sx={{ display: { xs: "block", sm: "none" } }}>
            <Grid item xs={12}>
              <Divider />
            </Grid>
          </Box>
        </Grid>
      </SubCard>

      {openEdit && (
        <Dialog open={openEdit} onClose={() => setOpenEdit(false)}>
          <DialogTitle>Update Education Details</DialogTitle>
          <DialogContent>
            <UpdateEducationDetails setAlumniDetails={setAlumniDetails} setOpenEdit={setOpenEdit} alumniDetails={workDetails} alumniId={alumniId} />
          </DialogContent>
        </Dialog>
      )}
      {openDelete && (
        <Dialog open={openDelete} onClose={() => setOpenDelete(false)}>
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            Are you sure you want to delete your Education Detail of{" "}
            <Typography component="span" fontWeight="bold" color="primary">
              {removeDetails?.instituteName}
            </Typography>
            ?
          </DialogContent>
          <DialogActions>
            <Box
              sx={{
                mt: 2,
                display: "flex",
                justifyContent: "flex-end",
                width: "100%",
              }}
            >
              <Button
                variant="contained"
                color="secondary"
                onClick={() => setOpenDelete(false)}
              >
                Close
              </Button>
              <Button
                variant="contained"
                color="error"
                sx={{ ml: 2 }}
                onClick={handleDeleteWorkExperience}
              >
                Delete
              </Button>
            </Box>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

export default EducationDetailsCard;
